"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileButtonState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const react_dom_1 = require("react-dom");
const slate_react_1 = require("slate-react");
const json_crdt_1 = require("json-joy/lib/json-crdt");
const file_1 = require("../../behavior/file");
class FileButtonState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.open = ui_1.rsync.val(false);
        this.busy = ui_1.rsync.val(false);
        this.anchorRect = ui_1.rsync.val(null);
        this.setAnchorRect = (rect) => {
            this.anchorRect.set(rect);
        };
        this.setAnchorEl = (el) => {
            this.anchorRect.set(el ? el.getBoundingClientRect() : null);
        };
        this.setAnchorFromCaret = () => {
            const rect = this.mutxt.api.focusRect();
            this.anchorRect.set(rect ?? null);
        };
        this.toggle = () => {
            if (!this.canOpen.value)
                return;
            this.open.set(!this.open.value);
        };
        this.close = () => {
            this.open.set(false);
            this.anchorRect.set(null);
            this.mutxt.api.focus();
        };
        /**
         * Programmatically pick a file via a hidden `<input type="file">` and insert
         * it as a `<file>` block. Returns the new thing ID, or null on cancel/error.
         */
        this.pickAndInsert = async () => {
            if (!this.canOpen.value)
                return null;
            return new Promise((resolve) => {
                const input = document.createElement('input');
                input.type = 'file';
                input.style.display = 'none';
                input.addEventListener('change', async () => {
                    const file = input.files?.[0];
                    document.body.removeChild(input);
                    if (!file) {
                        resolve(null);
                        return;
                    }
                    try {
                        const id = await this.insertFromFile(file);
                        resolve(id);
                    }
                    catch {
                        resolve(null);
                    }
                });
                document.body.appendChild(input);
                input.click();
            });
        };
        /** Read a `File` blob and insert a `<file>` block referencing it. */
        this.insertFromFile = async (file) => {
            if (!this.canOpen.value)
                return null;
            (0, react_dom_1.flushSync)(() => this.busy.set(true));
            try {
                const bytes = new Uint8Array(await file.arrayBuffer());
                const id = this.mutxt.things.add({
                    '@type': 'file',
                    name: file.name,
                    mimeType: file.type || 'application/octet-stream',
                    size: file.size,
                    data: json_crdt_1.s.con(bytes),
                });
                // Ensure we have an editor selection before inserting; default to end.
                if (!this.editor.selection) {
                    try {
                        slate_react_1.ReactEditor.focus(this.editor);
                    }
                    catch { }
                }
                (0, file_1.insertFile)(this.editor, id, undefined);
                this.mutxt.sync(true);
                return id;
            }
            finally {
                this.busy.set(false);
                this.close();
            }
        };
        this.editor = mutxt.editor;
        this.canOpen = ui_1.rsync.comp([mutxt.readOnly], ([readOnly]) => !readOnly);
    }
}
exports.FileButtonState = FileButtonState;
